<template>
  <div class="musiccontainer _musiccontainer">
   <NavTop :navid = id />
    <div class="home_box">
       <img v-lazy="backimg" alt="" class="julihe_bannerimg">
       <div class="article_box">
           <div class="article_title" style="margin-bottom:1vh;">联系我们</div>
           <div class="contactmebox_li" v-for="item in contactmelist" :key="item.id">
               <div class="contactme_header" v-lazy:background-image="item.thumbnail" style="background-size:cover;">
                  <div class="contentme_model">{{item.post_title}}</div>
               </div>
               <div class="contactme_textbox">
                    <div>集团热线：{{item.group_tel}}</div>
           <div>业务电话：{{item.business_tel}}</div>
           <div>邮箱：{{item.email}}</div>
           <div>地址：{{item.address}}</div>
               </div>
           </div>
           <div style="width:80%;margin-left:10%;text-align:center;">
             <img src="/static/img/wechat123.png" alt="" style="width:100%;">
             <div style="color: #333;font-size: 1rem;line-height: 45px;">微信公众号</div>
           </div>
            <div  style="width:80%;margin-left:10%;text-align:center;">
             <img src="/static/img/_u89.png" alt="" style="width:100%;">
             <div style="color: #333;font-size: 1rem;line-height: 45px;">企业抖音号</div>
           </div>
       </div>
    </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop'
import {getcontactmebackimg, getcontactmelist} from '../../api/jslihe'
export default {
  name: '',
  components: {
    NavTop
  },
  data () {
    return {
      id: Number(this.$route.query.id),
      backimg: '',
      contactmelist: []
    }
  },
  mounted () {
    this.getcontactmemsg()
  },
  methods: {
    getcontactmemsg () {
      getcontactmebackimg({id: 19}).then(res => {
        console.log(res)
        this.backimg = res.data.more.thumbnail
      })
      getcontactmelist().then(response => {
        console.log(response)
        this.contactmelist = response.data.list
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .contactmebox_li{
    .contactme_header{
     width:100%;
     height: 30vh;
     color:#fff;
     font-weight: bold;
     font-size:2.5rem;
     text-align: center;
     line-height: 30vh;
     .contentme_model{
       width:100%;
       height:100%;
       background:rgba(0, 0, 0, 0.6);
       text-align: center;
     }
     .contentme_model:hover{
       background: none;
     }
    }
    .contactme_textbox{
    background: #F0F0F0;
    padding: 3vh 1vh 3vh 2vh;
    color: #333;
    font-size: 0.9rem;
    line-height: 45px;
    text-align: left;
    }
    .contactme_textbox:hover{
        background: #D9001B;
      color:#fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Music/Music.vue